.root {
  position: relative;
  display: inline-flex;
}

.trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  border: none;
  background: none;
  color: inherit;
  padding: 0;
}

.menu {
  position: fixed;
  z-index: var(--z-dropdown);
  display: flex;
  flex-direction: column;
  min-width: 13rem;
  padding: var(--space-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background-color: var(--color-surface);
  box-shadow: var(--shadow-md);
}

.item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: var(--control-height-md);
  padding: 0 var(--space-3);
  border: none;
  border-radius: var(--radius-md);
  background: none;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
  text-align: left;
  white-space: nowrap;
}

.item:hover:not(:disabled),
.item:focus-visible {
  background-color: var(--color-surface-2);
}

.item:disabled {
  color: var(--color-text-muted);
}

.danger {
  color: var(--color-danger);
}
